import apiClient from '../api-client';

// Dashboard Banners: featureTileTypeId 1
// BrandBuilder Banners: featureTileType 2 (this is an assumption at this point)
export default {
	getFeatureBannersByTypeId(featureTileTypeId) {
		return apiClient().post('/FeatureTile/GetAllFeatureTilesByTypeAsync', {
			featureTileTypeId,
		});
	},
};
